import * as styles from './MetaLinkRenderer.css';
import { useCallback } from 'react';
import { Link } from 'src/components/NavLink/NavLink';
import { jobMetaClick } from 'src/store/search/search';
import type { SearchParams } from '@seek/chalice-types';
import { useDispatch, useSelector } from 'src/store/react';
import { useIsSplitViewEnabled } from 'src/store/featureFlags/hooks';
import { selectNormalisedCompanyName } from 'src/store/selectors';

interface Props {
  item: {
    params: SearchParams;
    title: string;
    name: string;
  };
  type: Parameters<typeof jobMetaClick>[0];
  disabledLink?: boolean;
  isChild?: boolean;
  rel?: string;
  shouldUseNormalisedCompanyName?: boolean;
}

const MetaLinkRenderer = (props: Props) => {
  const {
    type,
    disabledLink = false,
    isChild = false,
    item: { name, params: query, title },
    rel,
    shouldUseNormalisedCompanyName,
  } = props;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(jobMetaClick(type));
  }, [dispatch, type]);

  const isSplitView = useIsSplitViewEnabled();
  const shouldAddUnderline = isSplitView && !disabledLink;

  const normalisedCompanyName = useSelector(selectNormalisedCompanyName);
  const normalisedQuery: SearchParams =
    shouldUseNormalisedCompanyName && normalisedCompanyName
      ? {
          ...query,
          keywords: normalisedCompanyName,
        }
      : query;

  return (
    <Link
      className={[
        styles.root,
        { [styles.disabledLink]: disabledLink },
        { [styles.linkUnderline]: shouldAddUnderline },
      ]}
      tabIndex={disabledLink ? -1 : undefined}
      location={{
        pathname: '/jobs',
        query: normalisedQuery,
      }}
      rel={rel}
      onClick={onClick}
      title={title}
      aria-label={title}
      data-automation={`job${type.charAt(0).toUpperCase()}${type.slice(1)}`}
    >
      {(isChild && `(${name})`) || name}
    </Link>
  );
};

export default MetaLinkRenderer;
